var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#EA5504"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.696 28.224V30.08H23.32L23.32 40.224H21.144L21.144 30.08H17.704V28.224H26.696ZM32.2966 38.464C34.6646 38.464 36.1686 36.8 36.1686 34.224C36.1686 31.648 34.6646 29.984 32.2966 29.984C29.9446 29.984 28.4246 31.648 28.4246 34.224C28.4246 36.8 29.9446 38.464 32.2966 38.464ZM26.2486 34.224C26.2486 30.624 28.7606 28.096 32.2966 28.096C35.8486 28.096 38.3446 30.624 38.3446 34.224C38.3446 37.824 35.8486 40.352 32.2966 40.352C28.7606 40.352 26.2486 37.824 26.2486 34.224ZM44.6751 34.544C45.8911 34.544 46.6591 33.68 46.6591 32.32C46.6591 30.96 45.8911 30.08 44.6751 30.08H41.7631V34.544L44.6751 34.544ZM39.5871 40.224V28.224H44.7551C47.1551 28.224 48.8351 29.904 48.8351 32.32C48.8351 34.736 47.1551 36.416 44.7551 36.416L41.7631 36.416V40.224H39.5871Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon_top.ca2d85e500ff9a1d53adbde6355972a6.svg";
export { ForwardRef as ReactComponent };